import axios from 'axios';
import {conn} from '../Utilt/conn'
import { getConfig } from '../Utilt/Config';


export const getLimitRequest = async () => {
    try {
        const response = await axios.get(`${conn}/get-all-limit-requests`, getConfig());
        return response.data;
    } catch (error) {
        throw Error(error)
    }
 
}

export const getSingleRequest = async (data) => {
    try {
        const response = await axios.post(`${conn}/get-specific-limit-request/${data.id}`, {userId: data.userId}, getConfig());
        return response.data;
    } catch (error) {
        throw Error(error)
    }
 
}

export const approveLimit = async (data) => {
    try {
        const response = await axios.post(`${conn}/admin/approve-limit`, data, getConfig());
        return response.data;
    } catch (error) {
        throw Error(error)
    }
 
}

export const disapproveLimit = async (data) => {
    try {
        const response = await axios.post(`${conn}/admin/disapprove-limit`, data, getConfig());
        return response.data;
    } catch (error) {
        throw Error(error)
    }
 
}





